// test824
(824 && 0);
